import { render } from "./LazyBaseLink.vue?vue&type=template&id=6eef5526&scoped=true"
import script from "./LazyBaseLink.vue?vue&type=script&lang=ts"
export * from "./LazyBaseLink.vue?vue&type=script&lang=ts"

import "./LazyBaseLink.vue?vue&type=style&index=0&id=6eef5526&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6eef5526"

export default script